import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useOktaAuth } from "@okta/okta-react";
import axiosInstance from "../../../api";
import OnlineOrderValuesModel from "../../../models/formModels/onlineOrderValues.model";
import OnlineOrderActions from "../../../OnlineOrderActions";

function useOrderDetail(
 id: string
): UseQueryResult<AxiosResponse<OnlineOrderValuesModel>> {
 const { authState } = useOktaAuth();
 const orderActions = new OnlineOrderActions(null, null, null, [],'');
 return useQuery({
  queryKey: ["orderDetail", id],
  refetchOnWindowFocus:false,
  queryFn: ({ queryKey }) => {
   const [_key, id] = queryKey;
   return axiosInstance
    .get(`/v1/orders/new-flow/${id}`, {
     headers: {
      Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
     },
     transformResponse: orderActions.transformResponse,
    })
    .then((res) => res.data);
  },
  enabled: !!authState?.accessToken?.accessToken && !!id,
 });
}

export default useOrderDetail;
